import { Component, ElementRef, OnInit, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import * as d3 from 'd3';
import { HttpClient } from '@angular/common/http';

// **************************************************************************************************************
// Reference code.
// **************************************************************************************************************
// https://opensource.com/article/17/8/d3-angular#comments
// https://github.com/RHGeek/d3-ng-visual-awesomesauce/blob/master/examples/sunburst/src/app/park-sunburst/park-sunburst.component.ts
//
// Tutorials
// https://github.com/d3/d3/wiki/Tutorials
//
//
// REFERENCE CODE FOR BREADCRUMBS AND CENTER.
// https://bl.ocks.org/kerryrodden/766f8f6d31f645c39f488a0befa1e3c8
// **************************************************************************************************************

@Component({
  selector: 'app-starburst-v4',
  templateUrl: './starburst-v4.component.html',
  styleUrls: ['./starburst-v4.component.scss']
})
export class StarburstV4Component implements OnInit {
  element: ElementRef;

  
  @Output()
  ArcClicked: EventEmitter<any> = new EventEmitter<any>();
  
  private StarburstData: any;
  private treeData: any;
  /*
  private data: any[] = [
    {"LearnContext":"LEARN","LearnID":7,"UserID":1,"HierarchyPosition":"/7/","SomethingToLearn":"Angular.io","WhyItsImportant":"Web Development","ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-11-28T12:28:49.22","HierarchyLevel":1,"HierarchyString":"/7/","ParentLearnContext":"LEARN","ParentLearnID":0,"Children":
    [
      {"LearnContext":"LEARN","LearnID":4,"UserID":1,"HierarchyPosition":"/7/4/","SomethingToLearn":"Angular 5 Migration","WhyItsImportant":"To get this to work.","ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-10-17T21:54:09.123","HierarchyLevel":2,"HierarchyString":"/7/4/","ParentLearnContext":"LEARN","ParentLearnID":7,"Children":[
        {"LearnContext":"LEARN","LearnID":9,"UserID":1,"HierarchyPosition":"/7/4/0/","SomethingToLearn":"Web Development","WhyItsImportant":null,"ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-12-01T15:39:04.06","HierarchyLevel":3,"HierarchyString":"/7/4/0/","ParentLearnContext":"LEARN","ParentLearnID":4,"Children":[],"EffectiveUTC":"2017-12-01T15:39:04.063","ExpirationUTC":"9999-12-31T23:59:59.997","Tags":[],"Resources":[]}
        ,{"LearnContext":"LEARN","LearnID":11,"UserID":1,"HierarchyPosition":"/7/4/0.1/","SomethingToLearn":"Performance","WhyItsImportant":null,"ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-12-01T15:39:13.753","HierarchyLevel":3,"HierarchyString":"/7/4/0.1/","ParentLearnContext":"LEARN","ParentLearnID":4,"Children":[],"EffectiveUTC":"2017-12-01T15:39:13.753","ExpirationUTC":"9999-12-31T23:59:59.997","Tags":[],"Resources":[]}
        ,{"LearnContext":"LEARN","LearnID":12,"UserID":1,"HierarchyPosition":"/7/4/0.2/","SomethingToLearn":"Bootstrap 4","WhyItsImportant":null,"ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-12-01T15:39:18.64","HierarchyLevel":3,"HierarchyString":"/7/4/0.2/","ParentLearnContext":"LEARN","ParentLearnID":4,"Children":[],"EffectiveUTC":"2017-12-01T15:39:18.64","ExpirationUTC":"9999-12-31T23:59:59.997","Tags":[],"Resources":[]}
        ,{"LearnContext":"LEARN","LearnID":13,"UserID":1,"HierarchyPosition":"/7/4/0.3/","SomethingToLearn":"Angular Animation","WhyItsImportant":null,"ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-12-01T15:39:43.98","HierarchyLevel":3,"HierarchyString":"/7/4/0.3/","ParentLearnContext":"LEARN","ParentLearnID":4,"Children":[],"EffectiveUTC":"2017-12-01T15:39:43.98","ExpirationUTC":"9999-12-31T23:59:59.997","Tags":[],"Resources":[]}
        ,{"LearnContext":"LEARN","LearnID":8,"UserID":1,"HierarchyPosition":"/7/4/1/","SomethingToLearn":"Angular Library Building","WhyItsImportant":null,"ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-12-01T15:38:48.233","HierarchyLevel":3,"HierarchyString":"/7/4/1/","ParentLearnContext":"LEARN","ParentLearnID":4,"Children":[],"EffectiveUTC":"2017-12-01T15:38:48.24","ExpirationUTC":"9999-12-31T23:59:59.997","Tags":[],"Resources":[]}
        ,{"LearnContext":"LEARN","LearnID":10,"UserID":1,"HierarchyPosition":"/7/4/2/","SomethingToLearn":"Service Workers","WhyItsImportant":null,"ComplexityID":0,"ComplexityName":null,"DepthID":0,"DepthName":null,"ScopeID":0,"ScopeName":null,"UsefulnessID":0,"UsefulnessName":null,"LearnLevelID":0,"LearnLevelName":null,"SkillTypeID":0,"SKillTypeName":null,"CommitmentID":1,"CommitmentValue":8,"CommitmentName":"Very Low  ","AddedUTC":"2017-12-01T15:39:09.2","HierarchyLevel":3,"HierarchyString":"/7/4/2/","ParentLearnContext":"LEARN","ParentLearnID":4,"Children":[],"EffectiveUTC":"2017-12-01T15:39:09.2","ExpirationUTC":"9999-12-31T23:59:59.997","Tags":[],"Resources":[]}]
        ,"EffectiveUTC":"2017-10-17T21:54:09.137","ExpirationUTC":"9999-12-31T11:59:59.997","Tags":[{"TagContext":"LEARN","TagContextKey":4,"TagText":"Database","TagID":22,"UserID":1},{"TagContext":"LEARN","TagContextKey":4,"TagText":"Insight Database","TagID":23,"UserID":1}],"Resources":[]}],"EffectiveUTC":"2017-11-28T12:28:49.293","ExpirationUTC":"9999-12-31T23:59:59.997","Tags":[],"Resources":[]}];

      */
  constructor(private e: ElementRef, private http: HttpClient) {

    
    // this.http.get('http://localhost:4200/assets/data.json')
    this.element = e;           

    this.http.get('../../../../../assets/d3/data.static/flare.json')
        .subscribe(data => {
         this.StarburstData  = data;
         //this.treeData = {name:'root', children:this.StarburstData};
         this.treeData = this.StarburstData;
         this.drawSunburst();
         });
  }

  ngOnInit() {

  }

  private SelectedArc: any;
  private arc: any;
  private color: any;
  private created: boolean;
  private height: number;
  private margin: number;
  private partition: any;
  private radius: number;
  private root: any;
  private svg: any;
  private tooltip: any;
  private width: number;
  private xScale: any;
  private yScale: any;
  private totalSize:any;
  private sequenceArray: any;
  private border:1;
  drawSunburst() {
    this.margin = 10;
    this.width = 1024; //this.element.nativeElement.offsetWidth - this.margin * 2;
    this.height = 768;//this.element.nativeElement.offsetHeight - this.margin * 2;
    this.radius = (Math.min(this.width, this.height) / 2) - this.margin * 2
    
    this.svg = d3.select(this.element.nativeElement).append('svg')
    .attr('width', this.width) //this.element.nativeElement.offsetWidth)
    .attr('height', this.height)//this.element.nativeElement.offsetHeight)
    .append('g')
    .attr('id', 'container')
    .attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ') rotate(-90 0 0)')
    .attr("border",this.border);
    this.svg.on('mouseleave', this.mouseleave);


    this.svg.append('svg:circle')
    .attr('r', this.radius)
    .style('opacity', 0);

    this.tooltip = d3.select(this.element.nativeElement)
      .append('div')
      .attr('id', 'tooltip')
      .style('position', 'absolute')
      .style('z-index', '10')
      .style('opacity', 0)
      .style('background-color', 'rgba(255, 255, 255, 0.6)')
      .style('font-family', 'calibri')
      .style('padding', '5px 10px');

    this.xScale = d3.scaleLinear()
      .range([0, 2 * Math.PI]);

    this.yScale = d3.scaleSqrt()
      .range([0, this.radius]);
    this.color = d3.scaleOrdinal(d3.schemeCategory10);

    this.partition = d3.partition();

    this.arc = d3.arc()
      .startAngle((d: any) => { return Math.max(0, Math.min(2 * Math.PI, this.xScale(d['x0']))); })
      .endAngle((d: any) => { return Math.max(0, Math.min(2 * Math.PI, this.xScale(d['x1']))); })
      .innerRadius((d: any) => { return Math.max(0, this.yScale(d['y0'])); })
      .outerRadius((d: any) => { return Math.max(0, this.yScale(d['y1'])); });
      

      this.updateChart();
  }
  
 
  private updateChart(): void {
      this.root = d3.hierarchy(this.treeData);
      this.root 
          .sum(function(d) { return d.size; })
          .sort(function(a, b) { return b.size - a.size; });

      /* JOIN new data with old elements */
      var desc = this.partition(this.root).descendants();
      let path = this.svg.selectAll('path')
          .data(desc);

      /* ENTER new elements present in new data */
      /* UPDATE old elements present in new data */
      const scope = this;
      path.enter()
        .append('path')
        .style('opacity', 1)
        .on('mouseover', (d) => scope.mouseoverArc(d))
        .on('mousemove', (d) => scope.mousemoveArc())
        .on('mouseout',  (d) => scope.mouseoutArc())
        .on('click',     (d) => scope.clickArc(d))
        .on('dblclick',     (d) => scope.doubleClickArc(d))
        .merge(path)      // ENTER + UPDATE
          .transition().duration(250)
          .attr('d', this.arc)
          .style('fill', (d: any) => {
            return this.color((d.children ? d : d.parent).data.name);
          })
          .style('stroke', '#ffffff')
          .style('cursor', (d: any) => {
            return (d.data.name === 'flare' ? 'pointer' : 'auto');
          })
          ;
          
      /* EXIT old elements not present in new data */
      path.exit()
        .transition()
        .duration(500)
        .remove();

      this.totalSize = path.datum().value;
  }

  private tooltipHTML(d: any): string {
    let html = '';
    html = `<strong>${d.data.name}</strong>`;
    return html;
}

private clickArc(d: any): void {
  // let clickedFilter = {};

  //if ( d.data.name === 'flare') {
    this.SelectedArc = d;
    this.ArcClicked.emit(this.SelectedArc);
  //}
}

private doubleClickArc(d: any): void {
  // let clickedFilter = {};

  // if ( d.data.name === 'flare') {
    this.SelectedArc = d;    
    this.FocusClick(d);
    this.ArcClicked.emit(this.SelectedArc);
  // }
}

public FocusClick(d) {
  
  const scope = this;

  this.svg.transition()
      .duration(750)
      .tween('scale', function() {
        const xd = d3.interpolate(scope.xScale.domain(), [d.x0, d.x1]),
            yd = d3.interpolate(scope.yScale.domain(), [d.y0, 1]),
            yr = d3.interpolate(scope.yScale.range(), [d.y0 ? 20 : 0, scope.radius]);
        return function(t) { scope.xScale.domain(xd(t)); scope.yScale.domain(yd(t)).range(yr(t)); };
      })
    .selectAll('path')
      .attrTween('d', function(d1) { return function() { return scope.arc(d1); }; });
}
  mouseoverArc(d: any): any {

    const percentage = (100 * d.value / this.totalSize); //.toPrecision(3);    
    
    let percentageString = '';
    if (percentage < 0.1) {
      percentageString = '< 0.1%';
    }
    else 
    {
      percentageString = percentage.toPrecision(3) + '%';
    }
    
    
    this.sequenceArray = d.ancestors().reverse();
    //sequenceArray.shift(); // remove root node from the array
    
    const dScope = this;
  
    // GRAY OUT EVERYTHING.
    d3.selectAll('path')
      .style('opacity', 0.3);

      let tArray = d.ancestors().reverse();
      tArray.shift();
      
      if(this.sequenceArray != null && tArray.length > 0) {
      this.svg.selectAll('path')
      .filter(function(node) {
                return (dScope.sequenceArray.indexOf(node) >= 0);
              })
      .style('opacity', 1);
      }
      else {
        this.svg.selectAll('path')
        //.transition()
        //.duration(50)
        .style('opacity', 1);
      }


    this.tooltip.html(this.tooltipHTML(d));


    return this.tooltip.transition()
        .duration(50)
        .style('opacity', 0.9);
  }

  /**
   * mouseoutArc: hides tooltip div when mouse moves out of arcs.
   * @returns {*}
   */
  mouseoutArc(): any {
    /*
    
   d3.selectAll('path').on('mouseover', null);
    
   let lscope = this;
  // Transition each segment to full opacity and then reactivate it.
    d3.selectAll('path')
      //.transition()
      //.duration(500)
      .style('opacity', 1)
      .on('end', function() {
            
            d3.selectAll('path').on('mouseover', (d) => lscope.mouseoverArc(d));

            });

*/
    return this.tooltip.style('opacity', 0);
  }

  /**
   * mousemoveArc: moves tooltip div as mouse moves over arcs.
   * @returns {*}
   */
  mousemoveArc(): any {
      return this.tooltip
          .style('top', (d3.event.pageY - 20) + 'px')
          .style('left', (d3.event.pageX + 20) + 'px');
  }

  mouseleave(d) {
    /*
    // Hide the breadcrumb trail
   // d3.select("#trail")
   //     .style("visibility", "hidden");
  
   const scope = this;

    // Deactivate all segments during transition.
    d3.selectAll('path').on('mouseover', null);
    */
    // Transition each segment to full opacity and then reactivate it.
    d3.selectAll('path')
        .transition()
        .duration(10)
        .style('opacity', 1);

    this.tooltip.style('opacity', 0);
    //    .on('end', function() {
    //            d3.selectAll('path').on('mouseover', (d1) => scope.mouseoverArc(d1));
    //          })
    
    /*
    //d3.select("#explanation")
    //    .style("visibility", "hidden");
    */
  }
  
  
}
